import { Link } from 'react-router-dom';
import MangaCard from '@/components/base/MangaCard';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">实时追踪，不再错过每一话</p>
        </div>
        <div className="flex items-center gap-3">
          <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新中
          </span>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            更多新作 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
        {latestUpdates.map((manga) => (
          <MangaCard key={manga.id} manga={manga} />
        ))}
      </div>

      <div className="mt-6 text-center sm:hidden">
        <Link
          to="/category"
          className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer"
        >
          查看更多新作 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}